import Film from 'src/components/Film';

function TiviPage() {
    return (
        <>
            <Film mediaType="tv" />
        </>
    );
}

export default TiviPage;
